import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { GridConfig } from '@frontend/sports/common/client-config-data-access';
import { SportConstant } from '@frontend/sports/common/core/data-access/constants';
import { VirtualCompetitionPrefix } from '@frontend/sports/common/core/data-access/sport-model';
import { StylesLazyLoadingService } from '@frontend/sports/deferred/feature/styles-loader';
import { GridSorting } from '@frontend/sports/grid/core/feature/model';
import { DeviceService, toBoolean } from '@frontend/vanilla/core';
import { Observable, tap } from 'rxjs';

import { SortingStateService } from '../event-list-shared/sport/services/sorting-state.service';
import { LiveEventListService, LiveSportOverviewModel } from './live-event-list.service';

@Injectable()
export class LiveEventListResolver {
    constructor(
        private liveService: LiveEventListService,
        private sortingState: SortingStateService,
        private device: DeviceService,
        private gridConfig: GridConfig,
        private stylesService: StylesLazyLoadingService,
    ) {}

    resolve(route: ActivatedRouteSnapshot): Observable<LiveSportOverviewModel> {
        const { sport, region, league, conference } = route.params;

        const sportId = parseInt(sport);
        const targetId = region && parseInt(region);

        const sorting = this.sortingState.get('live') || GridSorting.Competition;
        const fallback = !targetId && toBoolean(route.queryParams.fallback) !== false;
        const { leagueId, isVirtual } = this.getLeagueData(league);

        const filter = {
            sportId,
            regionId: sportId === SportConstant.Tennis ? undefined : targetId,
            tournamentId: sportId === SportConstant.Tennis ? targetId : undefined,
            conferenceId: conference,
            fallback: fallback && !this.device.isRobot,
            sorting,
            take: this.gridConfig.initialSize,
            leagueId,
            isVirtual,
        };

        this.stylesService.lazyLoad('live');

        return leagueId
            ? this.liveService.getLiveLeagues(filter)
            : this.liveService.getLiveSports(filter).pipe(tap((model) => this.liveService.notifyParent(model)));
    }

    private getLeagueData(league?: string): { leagueId?: number; isVirtual: boolean } {
        let isVirtual = false;

        if (!league) {
            return { leagueId: undefined, isVirtual };
        }

        const leagueIdRegex = new RegExp(`${VirtualCompetitionPrefix}(\\d+)`);
        const match = leagueIdRegex.exec(league);

        if (match) {
            isVirtual = true;
            league = match[1];
        }

        return { leagueId: parseInt(league), isVirtual };
    }
}
